/* «Студия». Оболочка — экран React: колонка #studio, затемнение и лист шаблона.
   Содержимое колонки пишет paintStudio (главная, каталог, «Текст» и остальные экраны).
   Класс #studio раздел меняет сам, поэтому React его не задаёт.
   Строку разметки React не хранит: повторный кадр стирал бы дорисовки экрана. */
import { useLayoutEffect } from 'react';
import { studioApi } from './module';
import { bindStudioPaint } from './paint';

export function Studio() {
  const api = studioApi();
  useLayoutEffect(() => {
    bindStudioPaint(true);
    return () => bindStudioPaint(false);
  }, []);
  useLayoutEffect(() => {
    const el = document.getElementById('studio');
    if (el) el.classList.add('pg', 'st');
    api.attach();
  }, [api]);
  return (
    <>
      <div id="studio" />
      <div className="bscrim" id="stScrim" />
      <aside className="side bsheet st-pre" id="stPre" role="dialog" aria-label="Шаблон" aria-hidden="true" />
    </>
  );
}
